import React from 'react';

import { Flex } from '@chakra-ui/react';
import OKRSidePanelSkeleton from 'components/RabbitOKRSidePanel/OKRSidePanelSkeleton';
import useUnsavedDataAlert from 'components/hooks/useUnsavedDataAlert';
import { useDispatch } from 'react-redux';
import {
  setClearProvidedFeedbackData,
  setClearRequestedFeedbackData,
} from 'screens/performanceReview/components/ContinuousFeedback/Drawers/slice/feedbackSlice';

import { BottomDrawer, DrawerBody, DrawerContent, DrawerHeader, primaryDrawerWidth } from 'uiToolkitV1/BottomDrawer';

import { resetState, useCompetencyDrawerState } from './competencyDrawerSlice';
import { Header } from './components/Header';
import { PrimaryPanelBody } from './components/PrimaryPanelBody';
import { SecondaryPanelBody } from './components/SecondaryPanelBody';
import { useGetLevelUpDetailsQuery } from './dataHooks';
import { useCompetencyQueryParams } from './helpers/useCompetencyQueryParams';
import { useDrawerOnQueryChange } from './helpers/useDrawerOnQueryChange';
import { useHasDataChanged } from './helpers/useHasDataChanged';
import { useOpenCompetencyDrawer } from './helpers/useOpenCompetencyDrawer';

export const CompetencyDrawer = () => {
  const dispatch = useDispatch();

  const { competencyId } = useCompetencyQueryParams();

  const { isLoading } = useGetLevelUpDetailsQuery();

  const { isOpen, isSecondaryPanelOpen, selectedPrimaryScreen } = useCompetencyDrawerState();

  const { closeCompetencyPanel } = useOpenCompetencyDrawer();

  const isCompetencyPanelOpen = selectedPrimaryScreen === 'COMPETENCY';

  const isCompetencyPanelDataUpdatedByUser = useHasDataChanged();

  const { showUnsavedDataAlertDialog } = useUnsavedDataAlert();

  const handleClose = () => {
    if (isCompetencyPanelOpen && isCompetencyPanelDataUpdatedByUser) {
      showUnsavedDataAlertDialog({
        onCancelCallback: () => {
          dispatch(resetState());
          closeCompetencyPanel();
        },
      });
    } else {
      dispatch(resetState());
      dispatch(setClearProvidedFeedbackData());
      dispatch(setClearRequestedFeedbackData());
      closeCompetencyPanel();
    }
  };

  useDrawerOnQueryChange();

  return (
    <BottomDrawer isOpen={isOpen} onClose={handleClose}>
      <DrawerContent
        width={isSecondaryPanelOpen ? `${primaryDrawerWidth + primaryDrawerWidth}px` : `${primaryDrawerWidth}px`}
      >
        {competencyId && isLoading && <OKRSidePanelSkeleton isLoaded={!isLoading} />}
        {(!competencyId || !isLoading) && (
          <>
            <DrawerHeader onClose={handleClose}>
              <Header />
            </DrawerHeader>
            <DrawerBody>
              <Flex borderRadius="8px" h="100%" bg="surface.EBEFF3" p="1" pb={0} mx={1}>
                <PrimaryPanelBody />
                {isSecondaryPanelOpen && <SecondaryPanelBody />}
              </Flex>
            </DrawerBody>
          </>
        )}
      </DrawerContent>
    </BottomDrawer>
  );
};
